// removed by extract-text-webpack-plugin
module.exports = {"modalBackground":"_2HDl_qGAif11UIFbeSxAnj","modalBox":"OabHzKXtS1ASFrDXfuYU4","heading":"_3F9s40tlGmLA2WRb-uh2NO","title":"_2RXM1z3BjVfRhW3GwwgQAU","closeBtn":"EZuXQFEN-DcYfvkHGVOG6","content":"_89RViugEYJHWrG-KsCojr","contentItem":"_2-zapUsWubMqV70MzwunCz","input":"_2c15-H9hUyXj8-_VolfS2t","symbol":"_1rIaff977risREV26Pnt5p"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/ModalForm.styl
// module id = 742
// module chunks = 0